import {createAction, props} from '@ngrx/store';

export const ShowInteractionCardAction = createAction('[Interaction] - Show interaction card',
    props<{ id: string }>());
export const HideInteractionCardAction = createAction('[Interaction] - Hide interaction card',
    props<{ id?: string }>());
